export type LangTextItem = {
    product_name: string;
    tab_product: string;
    tab_support: string;
    tab_specs: string;
    btn_buy: string;
};

export type LangTextType = {
    [key: string]: LangTextItem;
};

export const LangText: LangTextType = {
    us: {
        product_name: 'EcoFlow STREAM Plug & Play Solar System',
        tab_product: 'Overview',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Buy Now',
    },
    eu: {
        product_name: 'EcoFlow STREAM Plug & Play Solar System',
        tab_product: 'Overview',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Shop Now',
    },
    uk: {
        product_name: 'EcoFlow STREAM Solar System',
        tab_product: 'Overview',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Shop Now',
    },
    de: {
        product_name: 'EcoFlow STREAM Balkonkraftwerk - Basic Kit',
        tab_product: 'Übersicht',
        tab_support: 'Support',
        tab_specs: 'Technische Daten',
        btn_buy: 'Jetzt shoppen',
    },
    fr: {
        product_name: 'Kit solaire EcoFlow STREAM',
        tab_product: "Vue d'ensemble",
        tab_support: 'Support',
        tab_specs: 'Spécifications',
        btn_buy: 'Acheter',
    },
    es: {
        product_name: 'Kit Solar EcoFlow STREAM: energía solar inteligente.',
        tab_product: 'Descripción general',
        tab_support: 'Soporte',
        tab_specs: 'Especificaciones',
        btn_buy: 'Comprar Ahora',
    },
    it: {
        product_name: 'Kit Fotovoltaico EcoFlow STREAM',
        tab_product: 'Panoramica',
        tab_support: 'Assistenza',
        tab_specs: 'Specifiche',
        btn_buy: 'Acquista Ora',
    },
};
